export const textSanitizer = value => {
  const regexExp = value.replace(/\s\s+/g, ' ')
  const result = regexExp.trim()
  return result
}
